import { render, staticRenderFns } from "./AppLetturaReferto.vue?vue&type=template&id=470f4432&"
import script from "./AppLetturaReferto.vue?vue&type=script&lang=js&"
export * from "./AppLetturaReferto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports